import { render, staticRenderFns } from "./registerGuide.vue?vue&type=template&id=14625898&scoped=true"
import script from "./registerGuide.vue?vue&type=script&lang=ts"
export * from "./registerGuide.vue?vue&type=script&lang=ts"
import style0 from "./registerGuide.vue?vue&type=style&index=0&id=14625898&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14625898",
  null
  
)

export default component.exports